import * as React from "react"
import { Box } from "@mui/material"
import { formatPriceSymbol } from "@ui-seeker/utils"


export default function priceColumn(name, label) {
	return {
		name: name, label: label,
		options: {
			filter: false,
			customBodyRowRender: (value, { currency, newRelease }) => <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
				{formatPriceSymbol(value, currency, { displayZero: true })}
			</Box>
		}
	}
}